import React from "react";
import { Phone, Mail, MapPin, Sparkles } from "lucide-react";
import EnquiryForm from "../components/EnquiryForm";
import SEOHead from "../components/SEOHead";
import { CONTACT } from "../data/cruiseData";

export default function Contact() {
 return (
 <main className="pt-32 pb-24" data-testid="contact-page">
 <SEOHead
  title="Contact Magic Cruises Sydney | Enquire About Sydney Harbour Charters"
  description="Get a quick custom quote for your Sydney Harbour cruise. Call 1300 100 502 or send an enquiry , wedding, corporate, birthday, hens and private boat hire enquiries answered within 24 hours."
  image="https://customer-assets.emergentagent.com/job_magic-harbour-party/artifacts/srsraacs_sydney%20cruises%20boats.png"
  canonical="/contact"
  keywords="contact Magic Cruises, Sydney Harbour cruise enquiry, boat hire quote Sydney, King St Wharf charter contact"
  includeLocalBusiness
  breadcrumbs={[
   { name: "Home", url: "/" },
   { name: "Contact", url: "/contact" },
  ]}
 />
 <div className="mx-auto max-w-7xl px-5 lg:px-10 grid lg:grid-cols-5 gap-12">
 <div className="lg:col-span-2">
 <div className="eyebrow">Get In Touch</div>
 <h1 className="font-display text-5xl lg:text-7xl mt-3 text-ink leading-[1]">Let's plan your <span className="text-pink italic">magic</span> day.</h1>
 <p className="text-ink-soft mt-5 leading-relaxed text-lg">Send us a quick enquiry or call the team directly. We respond within 24 hours with a custom quote.</p>
 <div className="mt-8 space-y-4 text-sm font-medium">
 <a href={`tel:${CONTACT.phone1}`} className="flex items-center gap-3 text-ink hover:text-pink"><Phone className="w-4 h-4 text-pink" /> {CONTACT.phone1}</a>
 <a href={`tel:${CONTACT.phone2}`} className="flex items-center gap-3 text-ink hover:text-pink"><Phone className="w-4 h-4 text-pink" /> {CONTACT.phone2}</a>
 <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-ink hover:text-pink"><Mail className="w-4 h-4 text-pink" /> {CONTACT.email}</a>
 <div className="flex items-center gap-3 text-ink-soft"><MapPin className="w-4 h-4 text-pink" /> {CONTACT.address}</div>
 <div className="flex items-center gap-3 text-ink-soft"><Sparkles className="w-4 h-4 text-pink" /> Boarding: {CONTACT.embarkation}</div>
 </div>
 </div>
 <div className="lg:col-span-3"><EnquiryForm sourcePage="contact" /></div>
 </div>
 </main>
 );
}
